import type { RouteObject } from 'react-router';
import { GroceriesListPage } from './GroceriesListPage';
import { GroceryListDetailPage } from './GroceryListDetailPage';
import { ReceiptReviewPage } from './ReceiptReviewPage';

/** Routes for the groceries area (lists, shopping mode, live sync). Mounted inside RequireHousehold. */
export const groceriesRoutes: RouteObject[] = [
  { path: '/groceries', element: <GroceriesListPage /> },
  { path: '/groceries/:id', element: <GroceryListDetailPage /> },
  { path: '/groceries/:id/receipt', element: <ReceiptReviewPage /> },
];
